import React from "react";
import FeedbackPopup from "../../feedback-popup/";
import TrustpilotModal from "../../trustpilot-modal";

const FeedbackSegment = ({
  showFeedbackPopup,
  showTrustpilotModal,
  handleFeedbackClose,
  handleFeedbackProceed,
  handleSurveyFeedback,
  handleTrustpilotClose,
}) => {
  return (
    <>
      <FeedbackPopup
        isOpen={showFeedbackPopup}
        setIsOpen={handleFeedbackClose}
        onProceed={handleFeedbackProceed}
        onClose={handleFeedbackClose}
        onSubmit={handleSurveyFeedback}
      />
      <TrustpilotModal
        isOpen={showTrustpilotModal}
        onClose={handleTrustpilotClose}
      />
    </>
  );
};

export default FeedbackSegment;
